import { Component, type ReactNode } from "react";
import { reportError } from "../lib/alerts";

/**
 * Keeps one card's failure to that card. An uncaught render error unmounts the
 * whole page, so a single pickup reading bad data blanked a 140-card Pickups
 * Package the moment its chapter's text arrived. `fallback` is the same card
 * without the part that failed (its stored excerpt instead of the live text).
 */
export class CardBoundary extends Component<{ fallback: ReactNode; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error("A pickup card failed to render; showing its stored excerpt", error);
    reportError(error, { where: "pickup card" });
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
